export const highlight = {
  fontWeight: "bold",
  color: "var(--primary-red, #C00)",
};
